import { render, staticRenderFns } from "./transitacao.vue?vue&type=template&id=c9f2a978&"
import script from "./transitacao.vue?vue&type=script&lang=js&"
export * from "./transitacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports